import { IMessage, User, QuickReplies } from "react-native-gifted-chat";
import { IRasaResponse } from "./types";
import { CircumstancesType } from "../../constants";
/**
 * Random id for each message
 */

/**
 * Return a message after format
 * @param {Object} botMessageObj
 * @param {Object} botData
 */

// To do add compatibility for checkboxes (It will need create a custom schema similar tu slack)
export const createNewBotMessage = (
  botMessageObj: IRasaResponse,
  botData: User
): IMessage => {
  const { custom, buttons, text = "", image = "" } = botMessageObj;
  let quickReplies = {
    type: "radio",
    keepIt: false,
    values: [],
  } as QuickReplies;
  let video = "";
  if (custom?.type === "video") video = custom.url;
  if (isValidNotEmptyArray(buttons)) {
    quickReplies.values = buttons?.map((button) => ({
      title: button.title,
      value: button.payload,
    }));
  } else {
    if (custom) {
      quickReplies.type = custom?.payload?.template_type ?? "radio";
      quickReplies.values =
        custom?.payload?.buttons?.map((button) => ({
          title: button.title,
          value: button.payload,
        })) ?? [];
    }
  }

  return {
    createdAt: new Date(),
    _id: uuid(),
    user: botData,
    text,
    image,
    quickReplies,
    video,
  };
};

/**
 * Receives a string and botData and returns an empty bot message
 * @param {string} emptyMessage
 * @param {Object} botData
 */
export const createBotEmptyMessage = (
  emptyMessage: string,
  botData: User
): IMessage => {
  return {
    createdAt: new Date(),
    _id: uuid(),
    user: botData,
    text: emptyMessage,
  };
};

/**
 * Receive a string, userData and return user message
 * @param {string} text
 * @param {Object} userData
 */
export const createQuickUserReply = (
  text: string,
  userData: User
): IMessage => {
  return {
    createdAt: new Date(),
    _id: uuid(),
    user: userData,
    text,
  };
};

export const fetchOptions = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
};

/**
 * Receive an array and Returs true if is a valid array and its is not empty otherwise it returns false
 * @param {array} array
 */
export const isValidNotEmptyArray = (array: any[]): boolean => {
  return !!(array && array?.length && array?.length > 0);
};

export const uuid = () => {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
};

interface SlotObject {
  event: string;
  name: string;
  value: string;
  timestamp: number;
}

export const updateSlotArrayForUnCheckedCircumstances = (updateSlotArrayForUnCheckedCircumstances: SlotObject[], circumstances: CircumstancesType[]) => {
  const unCheckedCircumstances = Object.values(CircumstancesType).filter((value) => !circumstances.includes(value))

  const profileCircumstancesProperties = {
    [CircumstancesType.NEURODIVERSITY]: ["neuro_details", "neuro_diagnosed", "neuro_challenges"],
    [CircumstancesType.MENTAL_HEALTH]: ["mh_issues_current", "mh_issues_past", "mh_challenges"],
    [CircumstancesType.WELLBEING]: ["wb_current", "wb_past", "wb_challenges"],
    [CircumstancesType.DISABILITY]: ["disabilty_details", "disabilty_difficulties", "disabilty_challenges"]
  }

  return updateSlotArrayForUnCheckedCircumstances.map(obj => {
    for (const circumstance of unCheckedCircumstances) {
      const properties = profileCircumstancesProperties[circumstance];
      if (properties && properties.includes(obj.name)) {
        return { ...obj, value: "N/A" };
      }
    }
    return obj;
  });
}
